import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var list_view_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M3 6h11v1.5H3V6Zm3.5 5.5h11V13h-11v-1.5ZM21 17H10v1.5h11V17Z" }) });
export {
  list_view_default as default
};
//# sourceMappingURL=list-view.js.map
